



































import { $store } from "@/store";
import { LayoutSourceMetadataPage } from "@/store/layout_source/types";
import { Vue, Component } from "vue-property-decorator";
import PdfPageLayoutInsert from "../layout_controls/PdfPageLayoutInsert.vue";

@Component({
  components: {
    "ag-pdfpage-layout-insert": PdfPageLayoutInsert,
  },
})
export default class PdfPage extends Vue {
  get currentPage() {
    return $store.wizard.layoutPage;
  }

  get layoutActive() {
    return $store.wizard.layoutActive;
  }

  get pageAspectRatio() {
    const page = $store.layoutSources.layoutSource?.metadata.pages.find(
      (page) => page.index == this.currentPage
    ) as LayoutSourceMetadataPage;
    return page ? (page.height / page.width) * 1.0 : 1;
  }

  get pageUrl() {
    return $store.layoutSources.pageUrl(this.currentPage);
  }

  get layoutInserts() {
    return $store.layouts.layout?.inserts;
  }

  get pageWidth() {
    return $store.appearance.pdfViewerPageWidth;
  }

  get pageHeight() {
    return this.pageWidth * this.pageAspectRatio;
  }

  get pageWidthPx() {
    return `${this.pageWidth}px`;
  }

  get pageHeightPx() {
    return `${this.pageHeight}px`;
  }

  get pageScale() {
    return this.currentPage
      ? this.pageWidth /
          $store.layoutSources.getPageMetadata(this.currentPage).width
      : 1;
  }
}
